<template>
  <b-container class="px-0">
    <div v-for="view in views" :key="view.uuid">
      <b-row class="mb-3">
        <b-col cols="9">
          <router-link :to="`/user/${view.user.uuid}`">
            <img
              class="rounded-circle img-profile mr-2"
              :src="view.user.avatar"
              :alt="`${view.user.first_name} ${view.user.last_name}`"
            />
            {{ view.user.first_name }} {{ view.user.last_name }}
          </router-link>
        </b-col>
      </b-row>
    </div>
    <!-- Conditional button for loading more -->
    <div class="d-flex justify-content-center" v-if="page < totalPages">
      <b-btn variant="primary" size="lg" @click="loadMore()"
        >Load more<b-spinner v-if="loading" small></b-spinner
      ></b-btn>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'EducationalItemViewList',
  props: {
    uuid: String,
  },
  data() {
    return {
      loading: false,
      page: 1,
      totalPages: 0,
      views: [],
    }
  },
  mounted() {
    this.loadViews()
  },
  methods: {
    loadViews() {
      this.loading = true

      this.$http
        .get(`/admin/resources/${this.uuid}/views?page=${this.page}`)
        .then((res) => {
          this.views = res.data.data
          this.totalPages = res.data.meta.last_page
        })
        .finally(() => {
          this.loading = false
        })
    },

    loadMore() {
      this.page += 1
      this.loadViews()
    },
  },
}
</script>

<style scoped>
.img-profile {
  width: 24px;
  height: 24px;
}
</style>
